import { setElementRefList } from "../../../../middlewares/useElementRefList";
import useMap from "../../../utils/useMap";
import { ELMENT_REF_LIST_PROP_KEY, PREFIX_REF_LIST } from "../../enum";
import { getTemplateId } from "../../utils/useTemplateIdentify";


const store = useMap();

const getPool = (props) => {
    const templateId = getTemplateId(props);
    if (!store.has(templateId)) {
        store.set(templateId, useMap());
    }
    return store.get(templateId);
}

const createIfNotExist = (props, node, refName) => {
    const pool = getPool(props);
    if (!pool.has(refName)) {
        pool.set(refName, new Set());
    }
}

const addNode = (props, node, refName) => {
    createIfNotExist(props, node, refName);
    getPool(props).get(refName).add(node);
}

const getNodes = (props, refName) => Array.from(getPool(props).get(refName))

/** This just add entity to prop, the middleware will capture this property name to emit the element */
const useRefElementList = (refName, props, node) => {
    addNode(props, node, refName)
    // props[ELMENT_REF_LIST_PROP_KEY] = [refName, getNodes(props, refName)];
    setElementRefList(props, refName, getNodes(props, refName));
    return Promise.resolve();
}

export default useRefElementList;